import { useState, useLayoutEffect } from 'react'

export type Size = {
  width: number
  height: number
}

const useWindowSize = () => {
  const [size, setSize] = useState<Size>({ width: window.innerWidth, height: window.innerHeight })
  useLayoutEffect(() => {
    function updateSize() {
      setSize({ width: window.innerWidth, height: window.innerHeight })
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size
}
export default useWindowSize
